/**
 * @Author: Nenad Brcic
 * @Date: 29.05.16
 * @Email: neno@neno.ch
 */

import React, { PropTypes } from 'react';
import ObjectEntry from '../Object/Entry';
import NoRecordsFound from '../shared/NoRecordsFound';
import RelSectionTemplate from '../shared/RelSectionTemplate';

const MyCollectionObjects = ({ objects, title, deleteEntry }) => {
    const entries = objects.map(edge => (
        <ObjectEntry
            key={ edge.node.id }
            object={ edge.node }
            deleteEntry={ deleteEntry }
        />
    ));

    return (
        <RelSectionTemplate title={ title }>
            <ul className="object-list">
                {
                    entries.length ? entries : <NoRecordsFound key="no-entries" />
                }
            </ul>
        </RelSectionTemplate>
    );
};

MyCollectionObjects.propTypes = {
    objects: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    deleteEntry: PropTypes.func,
};

MyCollectionObjects.defaultProps = {
    objects: [],
};

export default MyCollectionObjects;


// WEBPACK FOOTER //
// ./app/components/MyCollection/MyCollectionObjects.jsx